import { addDays } from '../days';
import { releaseEntries } from '../releases/releaseCatalog';
import { UNREAD_WINDOW_DAYS } from '../releases/releaseEntries';
import { isTourId } from '../tours/tourRegistry';

import type { Campaign } from './campaignTypes';
import { explicitCampaigns, releaseCampaignId } from './explicitCampaigns';

// A release entry with a `tour` implies a campaign: its audience, while the
// entry is new, once. Announcements win over adoption nudges.
const RELEASE_CAMPAIGN_PRIORITY = 100;

const releaseCampaigns = Object.fromEntries(
  releaseEntries.flatMap(({ id, meta }) =>
    meta.announce && meta.tour != null && isTourId(meta.tour)
      ? [
          [
            releaseCampaignId(id),
            {
              tour: meta.tour,
              // A tour can only play for users who have the feature.
              audience:
                meta.access == null
                  ? meta
                  : { ...meta, modules: [meta.access.module] },
              // From deploy (no start: the entry ships with the feature).
              active: { until: addDays(meta.date, UNREAD_WINDOW_DAYS - 1) },
              accountsCreatedBy: meta.date,
              priority: RELEASE_CAMPAIGN_PRIORITY,
            } satisfies Campaign,
          ],
        ]
      : [],
  ),
);

export const campaigns: Readonly<Record<string, Campaign>> = {
  ...releaseCampaigns,
  ...explicitCampaigns,
};

export const getCampaignsForTour = (
  tourId: string,
): Array<[id: string, campaign: Campaign]> =>
  Object.entries(campaigns)
    .filter(([, campaign]) => campaign.tour === tourId)
    .sort(([, a], [, b]) => (b.priority ?? 0) - (a.priority ?? 0));
